import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {isAdmin} from '../../../../../shared/services/userService.js';

import './Price.scss';

class Price extends PureComponent {
  static propTypes = {
    freelance: PropTypes.object,
  };

  render() {
    const {freelance, isAdmin} = this.props;

    const priceMin = freelance?.price ?? 0;
    const priceMax = freelance?.price_short ?? 0;

    if (isAdmin) {
      return <div className="priceMin">
        <span>{priceMin} €</span>
        &nbsp;-&nbsp;
        <span>{priceMax} €</span>
        &nbsp;
      </div>;
    }

    return <div>Sur devis</div>;
  }
}

export default connect(
  state => ({
    currentUser: state.currentUser.user,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(Price);
